export const AnexoServiceName = {
    ProdutoLoteAnexo: "ProdutoLoteAnexo",
    ProdutoAnexo: "ProdutoAnexo",
    ControleReclamacaoAnexo: "ControleReclamacaoAnexo",
    ClienteAnexo: "ClienteAnexo",
    FormulaPadraoAnexo: "FormulaPadraoAnexo",
};
